var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modern-pie-chart',{attrs:{"title":_vm.title,"series":_vm.series,"labels":_vm.labels,"colors":_vm.chartColors,"height":300,"show-donut":false,"show-data-labels":true,"show-legend":true,"display-mode":_vm.displayMode}})}
var staticRenderFns = []

export { render, staticRenderFns }